module.exports = __webpack_public_path__ + "static/media/ten.0b0c25de.jpg";